let filters = {
	query: null,
	category: null,
	year: null,
	type: null,
	brand: null,
	page: 1,
};

let pagination = {
	total: 0,
	page_size: 10,
	max_page: 1,
};

var bebrands = [];

let loading = false;
let abortController;

let evFormData = {
	id: null,
	condition: null,
	email: null,
	accept_terms: false,
	accept_marketing: false,
};

function openCustomProductDialog() {
	const dialog = document.querySelector("#PopupModal-benewbike-header");
	dialog.show();
}

function selectProduct(id) {
	evFormData.id = id;
	goToStep(2);
}

function goToStep(num) {
	const step1 = document.querySelector("#be-step-one");
	const step2 = document.querySelector("#be-step-two");
	const stepNumber = document.querySelector("#be-step-number");
	const step1Title = document.querySelector("#be-step-one-title");
	const step2Title = document.querySelector("#be-step-two-title");
	const backButton = document.querySelector("#bike-evaluator-step-back");

	if (num === 1) {
		step2.classList.add("hidden");
		step1.classList.remove("hidden");

		stepNumber.innerHTML = "1";

		step1Title.classList.remove("hidden");
		step2Title.classList.add("hidden");

		backButton.classList.add("hidden");
	} else {
		step1.classList.add("hidden");
		step2.classList.remove("hidden");

		stepNumber.innerHTML = "2";

		step1Title.classList.add("hidden");
		step2Title.classList.remove("hidden");

		backButton.classList.remove("hidden");
	}
}

async function fetchProducts() {
	let container = document.querySelector(".bike-evaluator-product-grid");
	container.classList.add("loading");

	loading = true;

	if (abortController) {
		abortController.abort();
	}

	abortController = new AbortController();
	const signal = abortController.signal;

	try {
		let f = ["limit=10"];
		let fs = 0;
		f.push(`skip=${(filters.page - 1) * pagination.page_size}`);

		if (filters.query) f.push(`query=${filters.query}`);
		if (filters.category) {
			//f.push(`category=${filters.category}`);
			// fs++
		}
		if (filters.year) {
			f.push(`and[${fs}][year][$in][]=${filters.year}`);
			fs++;
		} else {
			const year = new Date().getFullYear();
			const minYear = year - 5;
			let oy = 0;
			for (let i = year; i >= minYear; i--) {
				f.push(`and[${fs}][year][$in][]=${i}`);
				oy++;
			}
			fs++;
		}
		if (filters.type) {
			f.push(`and[${fs}][product_type_id][$in][]=${filters.type}`);
			fs++;
		}
		if (filters.brand) {
			f.push(`and[${fs}][brand_id][$in][]=${filters.brand}`);
			fs++;
		} else {
			let o = 0;
			bebrands.forEach((x) => {
				f.push(`and[${fs}][brand_id][$in][]=${x.id}`);
				o++;
			});
			fs++;
		}

		const res = await fetch(
			`https://tradein.bike-room.com/shopify-utility/thunder?${f.join("&")}`,
			{ signal }
		);
		const data = await res.json();

		if (data.data.length === 0) {
			container.classList.remove("loading");
			container.innerHTML = `
						<div class='no-results'>
							${be_translations.no_items}
							<button class="bike-evaluator-button" onclick="openCustomProductDialog()">${be_translations.add_bike}</button>
						</div>
						`;
		}

		if (data.data.length > 0) {
			var innerHTML = "";
			data.data.forEach((product) => {
				const card = generateProductCard(product);
				innerHTML += card;
			});
			container.classList.remove("loading");
			container.innerHTML = innerHTML;
		}

		generatePages(data.total);
		loading = false;
	} catch (error) {
		loading = false;
	}
}

function generateProductCard(product) {
	const groupset = product.products_options.find(
		(o) => o.option.name === "groupset"
	)?.value;

	const wheelset = product.products_options.find(
		(o) => o.option.name === "wheels"
	)?.value;

	return `
				<div>
					<div class="bike-evaluator-card-image">
						<img src="${product.products_images[0].image.url}" loading="lazy" />
					</div>
					<div class="bike-evaluator-card-title">
						${product.model}
					</div>
					<div class="bike-evaluator-card-info">
						${groupset} ${groupset && wheelset ? "•" : ""} Mavic R-SYS SLR
					</div>
					<div style="display: flex; align-items: center; gap: 4px; margin-top: 12px;">
						<div class="bike-evaluator-chip">${product.categories[0]?.name}</div>
						<div class="bike-evaluator-chip">${product.year}</div>
					</div>
					<button class="bike-evaluator-button" style="margin-top: 12px;" onclick="selectProduct('${
						product.id
					}')">
						${be_translations.select_bike}
						<svg width="8" height="6" viewBox="0 0 8 6" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path d="M6.75 1.5L3.75 4.5L0.75 1.5" stroke="var(--color-body)" stroke-width="1.1" stroke-linecap="round" stroke-linejoin="round"></path>
						</svg>
					</button>
				</div>
		`;
}

function generatePages(total) {
	const container = document.querySelector(".bike-evaluator-pagination");

	if (total == 0) {
		pagination.total = 0;
		pagination.max_page = 1;
		container.classList.add("hidden");
		return;
	}

	pagination.total = total;
	pagination.max_page = Math.ceil(total / pagination.page_size);

	const max =
		filters.page < pagination.max_page - 4
			? filters.page + 2
			: pagination.max_page;
	const min = filters.page > 3 ? filters.page - 2 : 1;

	let innerHTML = "";
	for (let i = min; i <= max; i++) {
		const active = i === filters.page ? "current" : "";
		innerHTML += `<button class="${active}" onclick="changePage(${i})">${i}</button>`;
	}

	container.querySelector(".bike-evaluator-pagination-numbers").innerHTML =
		innerHTML;
	container.classList.remove("hidden");
}

function changePage(e) {
	if (loading) return;
	let v = parseInt(e);
	if (!v || v === filters.page) return;
	filters.page = v;
	fetchProducts();
}

async function generateBrandFilter() {
	let container = document.querySelector("#be-brand-filter-list");

	try {
		const res = await fetch(
			"https://tradein.bike-room.com/shopify-utility/thunder-brands"
		);
		const data = await res.json();

		if (data.data.length > 0) {
			var innerHTML = "";
			data.data.forEach((brand) => {
				const card = `
						<li class="custom-select--check">
							<label for="be-filter-brand-${brand.id}" tabindex="-1">
								<input type="radio" id="be-filter-brand-${brand.id}" name="be-brand-filter" value="${brand.id}">
								${brand.name}
							</label>
						</li>
					`;
				innerHTML += card;
			});
			container.innerHTML = innerHTML;
			bebrands = data.data;
			initBrands();
			fetchProducts();
		}
	} catch (error) {
		console.log(error);
	}
}

function showConfirmation(i) {
	const confDialog = document.querySelector("#PopupModal-confirmation-header");
	const t1 = document.querySelector("#evaluation-confirm-text");
	const t2 = document.querySelector("#report-confirm-text");

	if (i === 1) {
		t1.classList.remove("hidden");
		t2.classList.add("hidden");
	} else {
		t1.classList.add("hidden");
		t2.classList.remove("hidden");
	}

	confDialog.show();
}

async function submitEvaluation() {
	const body = {
		thunder_id: parseInt(evFormData.id),
		condition: parseInt(evFormData.condition),
		email: evFormData.email,
		consense: evFormData.accept_marketing,
		rate: Shopify.currency.rate,
	};

	const dialog = document.querySelector("#PopupModal-evaluation-header");
	const errorText = dialog.querySelector(".error-text");
	errorText.classList.add("hidden");
	let error = false;

	try {
		const res = await fetch(
			"https://tradein.bike-room.com/shopify-utility/evaluation",
			{
				method: "POST",
				headers: {
					"Content-Type": "application/json",
					Accept: "application/json",
				},
				body: JSON.stringify(body),
			}
		);
		const data = await res.json();
		if (data.success) {
			dialog.hide();
			showConfirmation(1);
		} else {
			error = true;
		}
	} catch (error) {
		error = true;
	} finally {
		if (error) {
			errorText.classList.remove("hidden");
		}
	}
}

async function submitCustomProduct(body) {
	const dialog = document.querySelector("#PopupModal-benewbike-header");
	const errorText = dialog.querySelector(".error-text");
	errorText.classList.add("hidden");
	let error = false;

	try {
		const res = await fetch(
			"https://tradein.bike-room.com/shopify-utility/new-bike-ask",
			{
				method: "POST",
				headers: {
					"Content-Type": "application/json",
					Accept: "application/json",
				},
				body: JSON.stringify(body),
			}
		);
		const data = await res.json();
		if (data.success) {
			dialog.hide();
			showConfirmation(2);
		} else {
			error = true;
		}
	} catch (error) {
		error = true;
	} finally {
		if (error) {
			errorText.classList.remove("hidden");
		}
	}
}

function init() {
	const queryInput = document.querySelector("#be-query-filter");
	const clearFilters = document.querySelector("#be-clear-filters");

	queryInput.addEventListener("input", (e) => {
		filters.query = e.target.value;
		filters.page = 1;
		fetchProducts();
	});

	const yearFilter = document.querySelector("#be-year-filter-list");
	yearFilter.addEventListener("change", (e) => {
		if (filters.year === e.target.value) return;
		clearFilters.classList.remove("hidden");

		const c = document.querySelector("#be-year-count");
		c.innerHTML = 1;
		c.classList.remove("hidden");

		filters.year = e.target.value;
		filters.page = 1;
		fetchProducts();
	});

	const typeFilter = document.querySelector("#be-type-filter-list");
	typeFilter.addEventListener("change", (e) => {
		if (filters.type === e.target.value) return;
		clearFilters.classList.remove("hidden");

		const c = document.querySelector("#be-type-count");
		c.innerHTML = 1;

		filters.type = e.target.value;
		filters.page = 1;
		fetchProducts();
	});

	clearFilters.addEventListener("click", (e) => {
		filters = {
			query: null,
			category: null,
			year: null,
			type: null,
			brand: null,
			page: 1,
		};
		clearFilters.classList.add("hidden");

		const filterNumbers = document.querySelectorAll(".custom-facet--count");
		filterNumbers.forEach((f) => {
			f.innerHTML = 0;
			f.classList.add("hidden");
		});

		fetchProducts();
	});

	const pagePrev = document.querySelector("#be-pagination-prev");
	const pageNext = document.querySelector("#be-pagination-next");

	pagePrev.addEventListener("click", (e) => {
		if (filters.page === 1) return;
		filters.page--;
		fetchProducts();
	});

	pageNext.addEventListener("click", (e) => {
		if (filters.page === pagination.max_page) return;
		filters.page++;
		fetchProducts();
	});

	// -----------------------------
	// Custom Product Dialog

	const newBikeForm = document.querySelector(
		"#PopupModal-benewbike-header form"
	);
	const newBikeContinue = document.querySelector("#be-new-bike-continue");
	const newBikeBack = document.querySelector("#be-new-bike-back");
	const newBikeStep1 = document.querySelector("#new-bike-step-one");
	const newBikeStep2 = document.querySelector("#new-bike-step-two");

	newBikeForm.addEventListener("change", (e) => {
		const requiredFields = newBikeForm.querySelectorAll("[required]");
		let valid = true;
		requiredFields.forEach((field) => {
			if (!field.value && field.name != "email") valid = false;
		});
		if (valid) newBikeContinue.removeAttribute("disabled");
		else newBikeContinue.setAttribute("disabled", true);
	});

	newBikeContinue.addEventListener("click", (e) => {
		newBikeStep1.classList.add("hidden");
		newBikeStep2.classList.remove("hidden");
	});

	newBikeBack.addEventListener("click", (e) => {
		newBikeStep2.classList.add("hidden");
		newBikeStep1.classList.remove("hidden");
	});

	newBikeForm.addEventListener("submit", (e) => {
		e.preventDefault();
		const formData = new FormData(e.target);

		const body = {
			email: formData.get("email"),
			consense: formData.get("marketing"),
			bikeData: {
				brand: formData.get("brand"),
				model: formData.get("model"),
				year: formData.get("year"),
				wheelset: formData.get("wheelset"),
				groupset: formData.get("groupset"),
			},
		};

		submitCustomProduct(body);
	});

	// -----------------------------
	// Step 2

	const conditionButtons = document.querySelectorAll(".be-condition-button");
	const submitButton = document.querySelector("#be-submit");
	const backButton = document.querySelector("#bike-evaluator-step-back");

	conditionButtons.forEach((button) => {
		button.addEventListener("click", (e) => {
			const condition = button.dataset.value;
			evFormData.condition = condition;
			button.classList.add("selected");
			conditionButtons.forEach((b) => {
				if (b !== button) b.classList.remove("selected");
			});
			submitButton.removeAttribute("disabled");
		});
	});

	backButton.addEventListener("click", (e) => {
		goToStep(1);
	});

	submitButton.addEventListener("click", (e) => {
		if (e.target.dataset.email != "") {
			evFormData.email = e.target.dataset.email;
			submitEvaluation();
			return;
		}

		const evalModal = document.querySelector("#PopupModal-evaluation-header");
		evalModal.show();
	});

	// -----------------------------
	// Step 2 Mail modal

	const modalEmail = document.querySelector("#be-eval-email");
	const modalTerms = document.querySelector("#be-eval-tos");
	const modalMarketing = document.querySelector("#be-eval-marketing");
	const evalSubmit = document.querySelector("#be-eval-submit");

	const emailErorr = document.querySelector("#be-eval-email-error");

	modalEmail.addEventListener("input", (e) => {
		evFormData.email = e.target.value;

		emailErorr.classList.add("hidden");

		if (evFormData.email && evFormData.accept_terms)
			evalSubmit.removeAttribute("disabled");
	});

	modalTerms.addEventListener("change", (e) => {
		evFormData.accept_terms = e.target.checked;
		if (evFormData.email && evFormData.accept_terms)
			evalSubmit.removeAttribute("disabled");
	});

	modalMarketing.addEventListener("change", (e) => {
		evFormData.accept_marketing = e.target.checked;
	});

	evalSubmit.addEventListener("click", (e) => {
		if (!evFormData.accept_terms || !evFormData.email) return;

		// Email regex
		const re = /\S+@\S+\.\S+/;
		if (!re.test(evFormData.email)) {
			emailErorr.classList.remove("hidden");
			return;
		}

		submitEvaluation();
	});

	generateBrandFilter();
}

function initBrands() {
	const brandFilter = document.querySelector("#be-brand-filter-list");
	const clearFilters = document.querySelector("#be-clear-filters");

	brandFilter.addEventListener("change", (e) => {
		if (filters.brand === e.target.value) return;
		clearFilters.classList.remove("hidden");

		const c = document.querySelector("#be-brand-count");
		c.innerHTML = 1;
		c.classList.remove("hidden");

		filters.brand = e.target.value;
		filters.page = 1;
		fetchProducts();
	});
}

function resetAll() {
	filters = {
		query: null,
		category: null,
		year: null,
		type: null,
		brand: null,
		page: 1,
	};

	pagination = {
		total: 0,
		page_size: 10,
		max_page: 1,
	};

	loading = false;
	abortController = null;
	evFormData = {
		id: null,
		condition: null,
		email: null,
	};

	const filterNumbers = document.querySelectorAll(".custom-facet--count");
	filterNumbers.forEach((f) => {
		f.innerHTML = 0;
		f.classList.add("hidden");
	});

	goToStep(1);
	fetchProducts();
}

document.addEventListener("DOMContentLoaded", init);
